<div id="submodule-edetailer" class="cw-module-card cwSubModule">
    <!-- einkommentieren, sobald das Grundgerüst für das Modul steht.-->
    <!--     *ngIf="institutionId > 0"> -->

    <!-- Header -->
    <div class="cw-flex-row">
        <!-- Modul-Titel -->
        <h2>{{ 'MODULES.INSTITUTIONS.EDETAILER.TITLE' | translate }}</h2>
    </div>

    <!-- Content -->
    <div class="cw-submodules">
        <div class="cw-submodule">
            <div class="cw-button-wrapper">
                <button mat-raised-button color="primary" (click)="openEdetailer()">
                    {{ 'MODULES.INSTITUTIONS.EDETAILER.OPEN' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
